import { render } from "./SubMenuSwiper.vue?vue&type=template&id=665f4776"
import script from "./SubMenuSwiper.vue?vue&type=script&lang=js"
export * from "./SubMenuSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__